import React, { useContext, useState } from 'react';

import { Card, Header, Select } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import HelpTooltip from 'components/common/HelpTooltip';
import { FileSelection } from 'components/modules/files/components';
import { SOURCE_TYPE_DEFAULT } from 'components/modules/files/constants/sources';
import { getImageUrl } from 'components/modules/files/services/files';
import {
  getFileProviderMetadata,
  getFilesByAssociations,
} from 'components/pages/BusinessProfilePage/components/MediaTab/MediaTab.utils';

import {
  ALL_IMAGES_FILTERED,
  EDIT_IMAGES_BUTTON_TEXT,
  MAX_ALLOWED_IMAGES,
  NO_IMAGES_SELECTED_TEXT,
} from './MediaMultipleImagesSelector.constants';
import ImageCard from './components/ImageCard';
import {
  ADDITIONAL_IMAGES_SELECTION_HELP_TOOLTIP,
  MULTIPLE_IMAGE_CATEGORIES,
} from '../../constants/media';
import { MediaContext } from '../../contexts/Media.context';
import { getCategoryOptions } from '../MediaFileEditModal/MediaFileEditModal.utils';

import './MediaMultipleImagesSelector.scss';

const propTypes = {};

const defaultProps = {};

export default function MediaMultipleImagesSelector() {
  const {
    filesMetadata,
    selectedFiles: selectedGlobalFiles,
    onSelectMultipleImages,
    refreshFilesMetadata,
    gmbLocation,
  } = useContext(MediaContext);

  const [selectedAssociationFilter, setSelectedAssociationFilter] = useState(null);

  const selectedFiles = getFilesByAssociations(
    selectedGlobalFiles,
    filesMetadata,
    MULTIPLE_IMAGE_CATEGORIES,
  );

  async function onSelectFiles(images) {
    setSelectedAssociationFilter(null);
    await onSelectMultipleImages(images);
  }

  function onCategoryChange(event, { value }) {
    setSelectedAssociationFilter(value);
  }

  const activeFilters = !_isEmpty(selectedAssociationFilter);
  const areFilesSelected = !_isEmpty(selectedFiles);

  const filteredImages = getFilesByAssociations(
    selectedFiles,
    filesMetadata,
    _isEmpty(selectedAssociationFilter) ? MULTIPLE_IMAGE_CATEGORIES : [selectedAssociationFilter],
  );

  return (
    <div className="media-multiple-images-selector">
      <div className="header-container">
        <Header as="h3">Additional Photos</Header>
        <HelpTooltip title="Additional Photos" content={ADDITIONAL_IMAGES_SELECTION_HELP_TOOLTIP} />
      </div>

      {areFilesSelected && (
        <div className="controls">
          <Select
            options={getCategoryOptions(null, gmbLocation)}
            value={selectedAssociationFilter}
            onChange={onCategoryChange}
            placeholder="Filter by category"
            clearable
          />
        </div>
      )}

      {!_isEmpty(selectedAssociationFilter) && _isEmpty(filteredImages) && (
        <p className="all-files-filtered">{ALL_IMAGES_FILTERED}</p>
      )}

      <FileSelection
        files={selectedFiles}
        onUpdateFiles={(images) => onSelectFiles(images)}
        uploadSourceType={SOURCE_TYPE_DEFAULT}
        maxAllowedImages={MAX_ALLOWED_IMAGES}
        hideImagesDeck
        noImagesSelectedText={NO_IMAGES_SELECTED_TEXT}
        editButtonText={EDIT_IMAGES_BUTTON_TEXT}
        hideEditButton={activeFilters}
        renderSelectedImages={() => {
          return (
            <Card.Group stackable doubling itemsPerRow={5}>
              {filteredImages.map((file) => {
                const url = getImageUrl(file);
                const fileMetadata = getFileProviderMetadata(file.id, filesMetadata);

                return (
                  <ImageCard
                    key={url}
                    file={file}
                    fileMetadata={fileMetadata}
                    onSave={refreshFilesMetadata}
                  />
                );
              })}
            </Card.Group>
          );
        }}
      />
    </div>
  );
}

MediaMultipleImagesSelector.propTypes = propTypes;
MediaMultipleImagesSelector.defaultProps = defaultProps;
